import { PropsWithChildren } from 'react';
import { Text, cn } from '@bridebook/aura';

export interface ISharedProps {
  className?: string;
}

interface IProps extends ISharedProps, PropsWithChildren {}

const InfoParagraph = ({ children, className }: IProps) => (
  <Text
    className={cn('mb-4 text-[20px] leading-6 whitespace-pre-wrap text-space-75', className)}
    data-name="info-paragraph">
    {children}
  </Text>
);

export default InfoParagraph;
